import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import React from "react";
import PlanHeader from "./planHeader";
import PlanCreate from "./planCreate";
import { PlanData } from "types/models/planMaster/planMasterApp";
const defaultPlan: PlanData = {
  planId: 0,
  planCategory: "",
  planClassification: "",
  planName: "",
  planCode: "",
  rentExclTax: 0,
  rentInclTax: 0,
  rentlTax: 0,
  validity: 0,
  primarySpeed: 0,
  primaryQuota: 0,
  secondarySpeed: 0,
  secondaryQuota: 0,
  speedType: "",
  planDuration: "",
  planType: "",
  popPlan: "",
  popBestSeller: "",
  popLable: "",
  popPrice: 0,
  popDuration: "",
  popOffer: "",
  status: "",
  createdBy: "",
  planGroupCode: "",
  rentInclTaxWithOtt: 0,
  rentExclTaxWithOtt: 0,
  groupCount: 0,
  basePriceOtt: 0,
  basePriceWifi: 0
};

const PlanIndex: React.FC<{}> = () => {
  
  return (
    <>
      <AppAnimate animation="transition.slideUpIn" delay={200}>
        <AppCard>

          <PlanHeader plan={defaultPlan} />
          <AppGridContainer>
            <PlanCreate Plan={defaultPlan} />
          </AppGridContainer>

        </AppCard>
      </AppAnimate>
      <AppInfoView />
    </>
  );
};

export default PlanIndex;
